import { Icon } from "./styled";
import Table from "./Table";

export { Icon };
export default Table;
